<template>
    <div v-if="currency !== defaultCurrency">
        {{$t('views.showcase_checkout.conversion_note', {currency_from: currency, currency_to: defaultCurrency, price: price})}}.
    </div>
</template>

<script>
    import {Utils} from "../../common/utils";

    export default {
        name: "ConversionNote",
        props: {
            price: {
                type: String,
                required: true
            },
            currency: {
              type: String,
              required: true
          }
        },
        data: () => {
            return {
                defaultCurrency: Utils.getDefaultCurrency()
            }
        }
    }

</script>
